import { Cookies } from "react-cookie";
import { Token } from "./setting";
const cookie = new Cookies();
export const isLogined = () => {
  const token = cookie.get(Token);
  return token !== null && token !== undefined && token !== "undefined";
};
